var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"twitter__container"},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):_vm._e(),_c('div',{ref:"tweetDiv"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }